import { inject, Injectable } from '@angular/core';
import { DefaultGearRepository } from '../../repositories/gear.repository';
import { SOFTLINE_API_GARAGE_VEHICLE, SOFTLINE_API_GARAGE_VEHICLES } from '../../garage.api';
import { Vehicle } from '../../models/vehicle';
import { ApiDataAccess } from '@softline/core';

@Injectable()
export class VehicleRepository extends DefaultGearRepository<Vehicle> {
  constructor() {
    super(inject(ApiDataAccess), 'vehicle', {
      retrieve: SOFTLINE_API_GARAGE_VEHICLES,
      create: SOFTLINE_API_GARAGE_VEHICLES,
      retrieveById: SOFTLINE_API_GARAGE_VEHICLE,
      updateById: SOFTLINE_API_GARAGE_VEHICLE,
    });
  }
}
